<ng-container>
  <div class="d-block">
    <div class="modal-body xbrl-preparation-dialog-content"
      infinite-scroll [infiniteScrollDistance]="10"
      [infiniteScrollUpDistance]="10" [scrollWindow]="false" [immediateCheck]="true" [alwaysCallback]="true"
      [ngClass]="{ 'padding-15' : documentType === documentTypeEnum.LogFile || documentType === documentTypeEnum.GenericTextFile, 'bg-white': setBackgroundColorWhite}">
      @if (isWageTaxHtmlDocument) {
      <div class="wage-tax-html-container" [innerHTML]="renderedWageTaxHtml"></div>
      } @else {
      <div cdkDropListGroup #pagelist>
        <div class="scoped-html" [id]="'renderDocumentElement'+documentId"></div>
      </div>
      }
    </div>
    <div class="modal-footer custom d-flex justify-content-center modal-footer--sticky">
      <button type="button" class="btn btn-sm btn-outline-primary btn-shadow" (click)="close()" translate="Button.Back">
      </button>
    </div>
  </div>
</ng-container>